// src/utils/deps-are-same.ts
var depsAreSame = (oldDeps, deps) => {
  if (oldDeps === deps) {
    return true;
  }
  for (let i = 0; i < oldDeps.length; i += 1) {
    if (!Object.is(oldDeps[i], deps[i])) {
      return false;
    }
  }
  return true;
};
var deps_are_same_default = depsAreSame;

export { deps_are_same_default };
